import React from 'react';

const Card = ({ cardDetails }) => (
  <div className={ 'card' }>
    <div className={ 'card__row' }>
      <i aria-hidden='true' className={ `fa ${cardBrands(cardDetails.get('brand'))}` } />
      <div>**** **** **** {cardDetails.get('last4')} </div>
    </div>
    <div className={ 'card__row card__row--align-right' }>
      <div>Expired: {cardDetails.get('expMonth')}/{cardDetails.get('expYear')}</div>
    </div>
  </div>
);

const cardBrands = (type) => ({
  Visa: 'fa-cc-visa card__icon',
  MasterCard: 'fa-cc-mastercard card__icon',
  'American Express': 'fa-cc-amex card__icon',
  Discover: 'fa-cc-diners-club card__icon',
  'Diners Club': 'fa-cc-discover card__icon',
  JCB: 'fa-cc-jcb card__icon',
  UnionPay: 'fa-credit-card-alt card__icon'
}[type]);

export default Card;



// WEBPACK FOOTER //
// ./app/components/reps/settings/paymentMethods/Card.jsx